/* eslint-disable no-undef */
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BannerProps {
  src: string;
  width: number;
  height: number;
  border?: boolean;
  link?: string;
}

const Banner: React.FC<BannerProps> = ({ src, width, height, link }) => {
  const navigation = useNavigate();
  const Image = () => {
    return (
      <img
        src={src}
        width={width}
        height={height}
        style={{ cursor: 'pointer' }}
      />
    );
  };

  if (!link) {
    return (
      <div style={{ padding: 0, margin: 0 }}>
        <Image />
      </div>
    );
  }

  if (link?.includes('http')) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <Image />
      </a>
    );
  }

  return (
    <div style={{ padding: 0, margin: 0 }} onClick={() => navigation(link)}>
      <Image />
    </div>
  );
};

export default Banner;
